var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#marketing-clip)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#marketing-clip-inner)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7 15.762h.776c.633 0 1.143-.51 1.143-1.143v-2.4H3.114c.267.815.42 1.638.45 2.446a1.135 1.135 0 0 0 1.135 1.097zM2.429 10.314h5.44s.045.038.068.053a15.303 15.303 0 0 0 2.735 1.372c1.014.388 2.073.678 3.193.86v.008c-.053.42.236.8.655.854h.1c.373 0 .7-.282.753-.663a43.68 43.68 0 0 0 0-11.627.762.762 0 0 0-.853-.655.762.762 0 0 0-.655.853v.008c-1.12.183-2.187.472-3.193.861-.952.366-1.859.815-2.735 1.371-.023.016-.045.03-.068.054h-5.44A1.905 1.905 0 0 0 .524 5.568v2.819c0 1.051.853 1.904 1.905 1.904v.023z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "marketing-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "marketing-clip-inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/Marketing.9467c3fc6420fbaaf57d3a69583afad7.svg";
export { ForwardRef as ReactComponent };